import { render } from "./QueueView.vue?vue&type=template&id=64f69a6a"
import script from "./QueueView.vue?vue&type=script&lang=js"
export * from "./QueueView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matt/Dev/convict-memorial-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__